var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 520 296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5FA",
    d: "M67.084 295.999c-6.575.149-23.494-25.104-27.541-30.147C18.83 240.034.778 207.66.023 173.771c-.807-35.907 20.224-65.506 48.14-86.28C86.8 58.735 134.188 43.375 181.24 35.345c33.987-5.802 68.467-9.167 102.96-8.923 17.458.123 34.93-.582 52.425-.388 13.291.147 27.021 1.853 38.449 8.634 19.587 11.631 23.968 34.954 9.807 52.67-13.078 16.358-43.041 38.475-20.49 59.711 7.008 6.6 17.247 8.908 26.846 8.137 9.599-.77 18.746-4.29 27.605-8.068 38.382-16.364 86.976-20.525 98.333 29.443 4.829 21.254 2.34 44.653.764 66.202-.766 10.476-.955 32.549-12.114 38.416a7.535 7.535 0 01-1.844.672c-20.82 4.702-436.68 14.148-436.897 14.148z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#357ABC",
    d: "M226 14h59l-32 182h-59l32-182z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#357ABC",
    d: "M281.5 29h59l-21 119h-59l21-119z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#357ABC",
    d: "M345 0h59l-21 119h-59L345 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B89F",
    fillRule: "evenodd",
    d: "M151.175 147.484l-2.534-19.857s-.81-2.632-1.69-3.932c-1.25-1.846-1.994-1.893-3.064-1.04-.623.495-1.168 2.589-.818 3.068.436.6.471.81.615 1.842.179 1.32.619 1.409 1.238 2.095l-.229 20.398 6.482-2.574z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8984D",
    fillRule: "evenodd",
    d: "M126.008 172.554l-2.138-.934 50.199-114.641-8.955-19.858 3.952-6.451 14.142 9.734-1.324 1.92-12.113-8.333-2.025 3.306 8.874 19.69-.207.474-50.405 115.093z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    fillRule: "evenodd",
    d: "M167.299 78.253l-2.133-.935 8.904-20.34-8.955-19.857 3.956-6.451 14.137 9.734-1.32 1.92-12.116-8.333-2.025 3.306 8.873 19.69-9.321 21.266z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#357ABC",
    fillRule: "evenodd",
    d: "M172.119 39.438l19.468 13.798a2.558 2.558 0 003.734-.915l.919-1.596a3.207 3.207 0 00-.822-4.143l-19.467-13.799a2.559 2.559 0 00-3.738.912l-.919 1.596a3.213 3.213 0 00.825 4.147z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#40B2B6",
    fillRule: "evenodd",
    d: "M97.382 153.23l-11.225 28.789 11.334 3.306 9.457-28.135-9.566-3.96z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B89F",
    fillRule: "evenodd",
    d: "M102.728 192.36l.942-5.353-16.847-6.97L84 188.435l18.728 3.925zM104.632 146.76h11.681v-13.187l-6.915-4.641-4.766 17.828z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    fillRule: "evenodd",
    d: "M99.317 124.641c0-6.23 4.073-12.23 11.272-9.917 4.474 1.44 2.488 5.038 2.488 11.252 0 3.037-4.439 5.762-4.439 5.762l-.965 3.618c-4.832-1.227-8.356-4.497-8.356-10.715z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFA88F",
    fillRule: "evenodd",
    d: "M109.53 127.739c-.814.806-1.305 6.911-.709 8.399.923 2.912 7.398 3.173 8.27-.323.518-1.41-1.515-1.702-.693-2.96 1.729-2.811-2.064-6.459-4.361-6.552-2.297-.094-.416-.966-2.507 1.436z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B89F",
    fillRule: "evenodd",
    d: "M105.804 125.835c-.039-2.219 1.362-.778 3.305 1.052.51.483 1.363.389-.307-4.673-1.273-3.839-6.67-4.855-3.843-6.665 4.197-2.687 8.873-2.391 11.91 3.446 3.037 5.836 2.617 15.017.592 17.587-1.791 2.281-7.752-1.48-8.827-4.832-1.152-3.606-2.78-2.815-2.83-5.915z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C989C",
    fillRule: "evenodd",
    d: "M99.356 125.739l11.918-6.938c2.223-1.285 4.283-1.904 2.987-4.132l-2.481-4.282a4.672 4.672 0 00-6.354-1.702l-6.619 3.827c-2.239 1.274-1.674 14.512.55 13.227z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.217,
    height: 2.437,
    x: 107.563,
    y: 118.789,
    fill: "#2C989C",
    rx: 0.969,
    transform: "rotate(-33.09 107.563 118.789)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B89F",
    fillRule: "evenodd",
    d: "M103.471 283.602l6.736-1.639-1.195 9.8-6.113-.117.572-8.044z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C989C",
    fillRule: "evenodd",
    d: "M102.14 294.594c.027 1.285 3.45.88 3.45.88l14.974-2.725s.187-1.273-.194-1.947c-.616-1.063-3.224-.171-9.598-2.554-1.406-.522-2.258 1.413-4.579 1.168-1.736-.199-2.266-1.604-3.481-.973-.619.327-.588 5.439-.572 6.151z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#35373D",
    fillRule: "evenodd",
    d: "M102.202 293.589c.246.479 3.742.389 3.742.389s14.581-2.671 14.433-3.247c-.49-1.947-8.737-2.593-9.605-3.115-1.281-.779-6.79-.467-7.994.16-.615.307-.895 5.186-.576 5.813zM114.642 189.028l-17.723-4.003-1.114 29.852 6.417 33.43.779 36.989 7.062-.214c1.149-.067 6.791-40.302 6.791-40.302l-2.212-55.752z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6B89F",
    fillRule: "evenodd",
    d: "M127.156 281.847l7.195-.931-.276 9.438-6.113-.518-.806-7.989z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#494C53",
    fillRule: "evenodd",
    d: "M127.156 286.149l7.397-.307c.623-.226 1.858-47.724 1.858-47.724l-3.964-48.926-26.698-2.153 2.644 25.219 6.786 18.482 11.977 55.409z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C989C",
    fillRule: "evenodd",
    d: "M126.478 294.594c.028 1.285 3.45.88 3.45.88l14.978-2.725s.183-1.273-.194-1.947c-.619-1.063-3.228-.171-9.602-2.554-1.405-.522-2.258 1.413-4.575 1.168-1.74-.199-2.27-1.604-3.48-.973-.623.327-.592 5.439-.577 6.151z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#35373D",
    fillRule: "evenodd",
    d: "M126.541 293.589c.245.479 3.741.389 3.741.389s14.582-2.671 14.434-3.247c-.491-1.947-8.737-2.593-9.606-3.115-1.281-.779-6.79-.467-7.993.16-.615.307-.896 5.186-.576 5.813z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C989C",
    fillRule: "evenodd",
    d: "M106.949 140.747c11.976-1.911 24.14 1.472 24.14 1.472a24.204 24.204 0 00-2.118 12.152c.848 9.08 5.198 20.741 5.77 25.662.249 2.142-.277 12.323-2.219 12.323l-35.965 8.122c-4.088.779 0-10.925 0-13.732l.362-33.095s5.21-7.437 7.507-9.368c1.705-1.41.346-3.185 2.523-3.536z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#40B2B6",
    fillRule: "evenodd",
    d: "M106.948 140.748a52.444 52.444 0 0110.482-.526c7.689.335-15.306 6-13.009 4.069 1.71-1.417.351-3.193 2.527-3.543z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#40B2B6",
    fillRule: "evenodd",
    d: "M117.422 156.392l27.364-4.793v-11.564l-23.692.269s-2.815 3.305-3.267 4.653c-.895 2.713-.405 11.435-.405 11.435z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateService);
export default __webpack_public_path__ + "static/media/createService.d51a170f87d4daced3550f25a3bdb3bd.svg";
export { ForwardRef as ReactComponent };